export default {
  SET_LIST_ORGANIZATIONS(state, payload) {
    state.listOrganizations = payload
  },
}